import { Text, YStack } from '@frontend/web-react';

export const StripeLoading = () => (
  <YStack gapY="sm" p="md">
    <Text type="h4">Setting up checkout…</Text>
  </YStack>
);
